import React from 'react';
import { Icon as IconBase, IconProps } from '../../Icon';
import { useCustomComponent } from '@/hooks';

export interface ChatInputIconProps extends IconProps {}

const IconComponent: React.FC<ChatInputIconProps> = props => {
  return <IconBase {...props} />;
};

export const ChatInputIcon: React.FC<ChatInputIconProps> = (
  props: ChatInputIconProps
) => {
  const Component = useCustomComponent({
    componentName: 'ChatInputIcon',
    Component: IconComponent,
  });

  return <Component {...props} />;
};
